// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

::ng-deep {
  /*===== learner map css ============*/
  /* Style-for leaner-map */
  /* box-detail*/
  /*--- dashboard-new circles style ---*/
  /* iCheck plugin Square skin, green
  ----------------------------------- */
  /* HiDPI support */
}
::ng-deep ::ng-deep .all-learner-maps .modal-open {
  overflow-x: hidden;
  overflow-y: scroll;
}
::ng-deep ::ng-deep .all-learner-maps .date-card {
  margin-top: 60px;
  margin-bottom: 60px;
}
::ng-deep ::ng-deep .all-learner-maps .arrow-wrapper {
  font-size: 24px;
}
::ng-deep ::ng-deep .all-learner-maps .clickable {
  cursor: pointer;
}
::ng-deep ::ng-deep .all-learner-maps .info-label {
  display: none;
  position: absolute;
  left: 5px;
  top: 5px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
::ng-deep ::ng-deep .all-learner-maps .product-imitation {
  background-color: #fff;
}
::ng-deep ::ng-deep .all-learner-maps .iphone .info-label {
  display: block;
}
::ng-deep ::ng-deep .all-learner-maps .popover-content p {
  padding-top: 5px;
}
::ng-deep ::ng-deep .all-learner-maps .modal-iphone {
  top: 132px;
  left: -3px;
  display: block;
  z-index: 1050;
  padding: 0px;
  margin-top: 10px;
  max-width: 100% !important;
  min-width: 200px !important;
}
::ng-deep ::ng-deep .all-learner-maps .modal-iphone .arrow {
  left: 50%;
  margin-left: -11px;
  border-top-width: 0;
  border-bottom-color: #999999;
  border-bottom-color: rgba(0, 0, 0, 0.25);
  top: -11px;
}
::ng-deep ::ng-deep .all-learner-maps .modal-iphone .arrow:after {
  border-bottom-color: #f7f7f7;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .product-desc {
  padding: 0;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .col-md-15 .col-md-15 {
  width: 100%;
}
@media (min-width: 680px) {
  ::ng-deep ::ng-deep .all-learner-maps .course-index .common-section-wrap.col-md-15 {
    max-width: 150px;
  }
}
::ng-deep ::ng-deep .all-learner-maps .course-index .common-section-wrap.row .lecture-small-box {
  padding: 0 10px;
  max-width: 150px;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .common-section-wrap.row .single-section-wrap {
  margin-left: 205px;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .product-box .btn-outline {
  position: absolute;
  right: 5px;
  top: 5px;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .btn-group .btn {
  border-radius: 0px;
  margin: 0.5px;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .product-box {
  position: relative;
  width: 100%;
  display: table;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .product-imitation {
  padding: 0px 5px;
  max-height: 130px;
  height: 130px;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  width: 100%;
  color: #676a6c;
  font-size: 20px;
  font-family: "MuseoSans-300";
}
::ng-deep ::ng-deep .all-learner-maps .course-index .product-imitation h3 {
  font-size: 20px;
  font-family: "MuseoSans-300";
}
::ng-deep ::ng-deep .all-learner-maps .course-index .product-imitation:focus {
  outline: none;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .lecture-small-box {
  position: relative;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .lecture-small-box .over-content .video-meta-wrapper {
  position: relative;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .lecture-small-box .over-content .video-meta-wrapper .ibox {
  margin: 0;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .lecture-small-box .over-content .video-meta-wrapper .ibox .ibox-title {
  border-top: 0;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .lecture-small-box .over-content .video-meta-wrapper .ibox-content .pull-left {
  max-width: 50%;
  width: 100%;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .lecture-small-box .over-content .video-meta-wrapper .ibox-content .pull-left .product-imitation {
  padding: 70px 0;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .lecture-small-box .over-content .video-meta-wrapper .ibox-content .pull-right {
  max-width: 45%;
  width: 100%;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .lecture-small-box .over-content .video-meta-wrapper .ibox-content .pull-right ul {
  padding-left: 20px;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .lecture-small-box .over-content .video-meta-wrapper .stat-percent {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .lecture-small-box .over-content .product-imitation {
  padding: 0px;
  height: auto;
  max-height: 100%;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .lecture-small-box .over-content .product-imitation img {
  max-width: 100%;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .arrow-icons .fa {
  font-size: 24px;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .lecture-state {
  top: 5px;
  position: absolute;
  right: 6px;
}
::ng-deep ::ng-deep .all-learner-maps .course-index .lecture-state .text-green {
  font-size: 19px;
}
::ng-deep ::ng-deep .all-learner-maps .text-green {
  color: #48ac51;
}
::ng-deep ::ng-deep .all-learner-maps .car-small-heading {
  font-family: "Marydale";
}
::ng-deep ::ng-deep .all-learner-maps .car-small-heading a {
  color: inherit;
}
::ng-deep ::ng-deep .all-learner-maps .practioner-dash-wrap {
  margin-top: -43px;
}
::ng-deep ::ng-deep .all-learner-maps .practioner-dash-wrap.cols-4 .col-sm-3 {
  width: 180px;
}
@media screen and (max-width: 991px) {
  ::ng-deep ::ng-deep .all-learner-maps .practioner-dash-wrap.cols-4 .col-sm-3 {
    display: inline-block;
    float: none;
    vertical-align: top;
  }
}
::ng-deep ::ng-deep .all-learner-maps .inline-profile {
  display: inline-block;
}
::ng-deep ::ng-deep .all-learner-maps .inline-profile .profile_types {
  display: inline-block;
  margin-left: 0px;
}
::ng-deep ::ng-deep .all-learner-maps h3.car-small-heading {
  font-size: 20px;
}
::ng-deep ::ng-deep .all-learner-maps h4.car-small-heading {
  font-size: 18px;
}
::ng-deep ::ng-deep .all-learner-maps .car-big-heading {
  font-family: "Bangers", cursive;
  font-size: 50px;
}
::ng-deep ::ng-deep .all-learner-maps .car-big-heading img {
  max-width: 550px;
  width: 100%;
}
::ng-deep ::ng-deep .all-learner-maps .car-big-heading small {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 23px;
  display: block;
}
::ng-deep ::ng-deep .all-learner-maps .course-index > h2 {
  margin: 0 auto;
  display: table;
  width: 563px;
}
::ng-deep ::ng-deep .all-learner-maps .course-index > hr {
  clear: both;
  padding-top: 20px;
  padding-bottom: 20px;
}
::ng-deep ::ng-deep .all-learner-maps .product-box {
  padding: 0;
  border: none;
  box-shadow: 10px 10px 10px -3px #676a6c;
}
::ng-deep ::ng-deep .all-learner-maps .product-box:hover, ::ng-deep ::ng-deep .all-learner-maps .product-box:active {
  border: none;
  box-shadow: 3px 3px 7px 0px #a8a8a8;
}
::ng-deep ::ng-deep .all-learner-maps .dashboard-wrapper .car-big-heading img {
  max-width: 325px !important;
}
::ng-deep ::ng-deep .all-learner-maps .practioner-dash-wrap {
  margin-top: 0px;
}
::ng-deep ::ng-deep .all-learner-maps .icon-btn {
  position: absolute;
  bottom: 5px;
  font-size: 22px;
  color: #676a6c;
  margin: auto;
  left: 0;
  right: 0;
  display: inline-block;
}
::ng-deep ::ng-deep .all-learner-maps .icon-btn:hover {
  color: #48ac51;
}
::ng-deep ::ng-deep .all-learner-maps .fs-logo-feedback {
  max-width: 350px;
  margin: 30px auto 0;
}
::ng-deep ::ng-deep .all-learner-maps #f-implement1 .profile-description {
  font-size: 15px;
}
@media (max-width: 960px) {
  ::ng-deep ::ng-deep .all-learner-maps #f-implement1 .profile-description {
    max-height: 245px;
    overflow: hidden;
    overflow-y: auto;
  }
}
@media (max-width: 767px) {
  ::ng-deep ::ng-deep .all-learner-maps #f-implement1 .profile-description {
    font-size: 12px;
    max-height: 310px;
  }
  body.mini-navbar ::ng-deep ::ng-deep .all-learner-maps #f-implement1 .profile-description {
    max-height: 302px;
  }
}
@media only screen and (max-height: 414px) and (orientation: landscape) {
  ::ng-deep ::ng-deep .all-learner-maps #f-implement1 .profile-description {
    max-height: 115px !important;
    font-size: 13px !important;
  }
}
::ng-deep ::ng-deep .all-learner-maps #f-implement1 .fix-label {
  font-size: 23px;
}
@media (max-width: 767px) {
  ::ng-deep ::ng-deep .all-learner-maps #f-implement1 .fix-label {
    font-size: 16px;
    float: left;
  }
}
::ng-deep ::ng-deep .all-learner-maps #f-implement1 .about-u {
  padding: 10px;
}
@media (max-width: 767px) {
  ::ng-deep ::ng-deep .all-learner-maps #f-implement1 .about-u {
    margin-bottom: 5px;
  }
  ::ng-deep ::ng-deep .all-learner-maps #f-implement1 .about-u .right-label-text {
    font-size: 16px;
    margin-bottom: 0px;
    display: inline-block;
    vertical-align: top;
    padding: 7px;
    background: rgb(0, 173, 208) !important;
    float: right;
  }
}
::ng-deep ::ng-deep .all-learner-maps #f-implement1 .right-label-text {
  font-size: 18px;
  color: #fff;
}
::ng-deep ::ng-deep .all-learner-maps #f-implement1 .right-label-text span {
  padding: 8px;
}
@media (min-width: 680px) {
  ::ng-deep ::ng-deep .all-learner-maps .new-dashboard .col-sm-3 {
    max-width: 180px;
  }
}
::ng-deep ::ng-deep .page-heading .col-lg-10 {
  /*float: left;
  width: 75%;*/
}
::ng-deep ::ng-deep .page-heading .col-lg-10.header-full h2 {
  padding-right: 0px;
}
@media only screen and (min-width: 769px) {
  ::ng-deep ::ng-deep .page-heading .col-lg-10.header-full {
    width: 60%;
  }
}
@media only screen and (max-width: 768px) {
  ::ng-deep ::ng-deep .page-heading .col-lg-10.header-full {
    width: 100%;
  }
  ::ng-deep ::ng-deep .page-heading .col-lg-10.header-full h2 {
    padding-right: 50px;
  }
}
::ng-deep ::ng-deep .page-heading .header-back {
  width: 25%;
  float: left;
  text-align: right;
  padding-right: 0;
  padding-top: 30px;
}
@media only screen and (max-width: 768px) {
  ::ng-deep ::ng-deep .page-heading .header-back {
    padding-top: 50px;
  }
}
::ng-deep ::ng-deep .page-heading .header-back.full-screen-option {
  width: 100%;
  padding-top: 10px;
  padding-right: 15px;
}
@media only screen and (min-width: 769px) {
  ::ng-deep ::ng-deep .page-heading .header-back.full-screen-option {
    width: 40%;
    padding-top: 30px;
  }
}
@media only screen and (max-height: 736px) and (orientation: landscape) {
  ::ng-deep ::ng-deep .page-heading .header-back.full-screen-option {
    padding-top: 0px;
    float: right;
    width: 50%;
    margin-top: -20px;
  }
}
::ng-deep ::ng-deep .course-index .ibox {
  position: relative;
}
::ng-deep ::ng-deep .course-index .ibox:hover .product-box {
  border: none;
  box-shadow: 3px 3px 7px 0px #a8a8a8;
}
::ng-deep ::ng-deep .course-index .ibox:hover .icon-btn {
  color: #48ac51;
}
::ng-deep ::ng-deep .course-index .ibox input[type=checkbox] {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 1;
}
::ng-deep ::ng-deep .course-index .ibox input[type=checkbox]:checked ~ div.product-box {
  border: none;
  box-shadow: 3px 3px 7px 0px #a8a8a8;
}
::ng-deep ::ng-deep .course-index .ibox input[type=checkbox]:checked ~ div.product-box a.icon-btn {
  color: #48ac51;
}
::ng-deep ::ng-deep .course-index .ibox input[type=checkbox]:checked ~ div.popover {
  display: block;
  top: 130px;
  left: -100px;
  margin-top: 15px;
}
@media screen and (max-width: 679px) {
  ::ng-deep ::ng-deep .course-index .ibox input[type=checkbox]:checked ~ div.popover {
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    max-width: 350px;
    min-width: auto;
    width: 100%;
  }
}
::ng-deep ::ng-deep .course-index .ibox input[type=checkbox]:checked ~ div.popover > .arrow {
  left: 50%;
  margin-left: -11px;
  border-top-width: 0;
  border-bottom-color: #999999;
  border-bottom-color: rgba(0, 0, 0, 0.25);
  top: -11px;
}
::ng-deep ::ng-deep .course-index .ibox input[type=checkbox]:checked ~ div.popover > .arrow:after {
  content: " ";
  top: 1px;
  margin-left: -10px;
  border-top-width: 0;
  border-bottom-color: #f7f7f7;
}
@media only screen and (max-width: 1400px) {
  ::ng-deep ::ng-deep .cta-wrapper .list-group-item span {
    max-width: 53%;
    word-wrap: break-word;
  }
}
::ng-deep ::ng-deep .img-shadow {
  box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.6);
  -moz-box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.6);
  -webkit-box-shadow: inset 0 0 8px rgba(0, 0, 0, 0.6);
  background-size: 100% !important;
  background-position: 0;
}
::ng-deep ::ng-deep .img-shadow .build-form {
  margin-top: 30px !important;
}
::ng-deep ::ng-deep .dash-practitioner-wrapper ::ng-deep .ibox.product-detail .ibox-content .image-imitation,
::ng-deep .wrapper-learner-map ::ng-deep .ibox.product-detail .ibox-content .image-imitation {
  min-height: 642px;
}
@media only screen and (max-width: 1400px) {
  ::ng-deep ::ng-deep .dash-practitioner-wrapper ::ng-deep .ibox.product-detail .ibox-content .image-imitation,
  ::ng-deep .wrapper-learner-map ::ng-deep .ibox.product-detail .ibox-content .image-imitation {
    min-height: 350px;
  }
}
::ng-deep ::ng-deep .dash-practitioner-wrapper ::ng-deep .ibox.product-detail .ibox-content .image-imitation .build-form,
::ng-deep .wrapper-learner-map ::ng-deep .ibox.product-detail .ibox-content .image-imitation .build-form {
  max-width: 300px;
  margin: 0 auto;
  float: none;
}
::ng-deep ::ng-deep .dash-practitioner-wrapper ::ng-deep .ibox.product-detail .ibox-content .image-imitation .build-form input[type=email],
::ng-deep .wrapper-learner-map ::ng-deep .ibox.product-detail .ibox-content .image-imitation .build-form input[type=email] {
  width: 90%;
}
::ng-deep ::ng-deep .dash-practitioner-wrapper ::ng-deep .ibox.product-detail .ibox-content .image-imitation .build-form .fa,
::ng-deep .wrapper-learner-map ::ng-deep .ibox.product-detail .ibox-content .image-imitation .build-form .fa {
  cursor: pointer;
}
::ng-deep ::ng-deep .dash-practitioner-wrapper ::ng-deep .ibox.product-detail .ibox-content .image-imitation .build-form fieldset,
::ng-deep .wrapper-learner-map ::ng-deep .ibox.product-detail .ibox-content .image-imitation .build-form fieldset {
  margin-bottom: 5px;
}
::ng-deep ::ng-deep span.spacer {
  display: block;
  clear: both;
  margin-bottom: 8px;
}
::ng-deep ::ng-deep .media-container.media-main {
  padding-top: 41%;
}
@media only screen and (max-width: 991px) {
  ::ng-deep ::ng-deep .media-container.media-main {
    padding-top: 61%;
  }
}
::ng-deep ::ng-deep .media-container.media-main .img-shadow {
  position: absolute;
}
::ng-deep ::ng-deep .media-container.media-main .video-sect-imitation {
  width: 100%;
  position: absolute;
  left: 0;
  top: 50%;
  min-height: inherit !important;
  overflow: auto;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
}
::ng-deep ::ng-deep .media-container.media-main .video-sect-imitation {
  height: 69%;
  margin: -12.5% 0 !important;
}
@media only screen and (max-width: 991px) {
  ::ng-deep ::ng-deep .media-container.media-main .video-sect-imitation {
    height: 92%;
    margin: -10.5% 0 !important;
  }
}
::ng-deep ::ng-deep .media-container {
  position: relative;
  padding-top: 0%;
}
@media only screen and (max-width: 991px) {
  ::ng-deep ::ng-deep .media-container {
    padding-top: 0%;
    margin: 15px 0px;
  }
}
::ng-deep ::ng-deep .media-container .image-imitation {
  width: 100%;
  position: static;
  left: 0;
  top: 0;
  height: 100%;
  min-height: inherit !important;
  overflow: auto;
  background-size: contain !important;
  background-position: center center;
}
::ng-deep ::ng-deep .media-container .image-imitation iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
::ng-deep ::ng-deep .work-well-slide h3 {
  font-size: 22px;
}
::ng-deep ::ng-deep .work-well-slide .title-sm {
  margin-bottom: 50px !important;
}
@media (max-width: 767px) {
  ::ng-deep ::ng-deep .work-well-slide .title-sm {
    margin-bottom: 25px !important;
  }
}
::ng-deep ::ng-deep .work-well-slide .disabled {
  height: 50px;
  vertical-align: middle;
  margin-top: 35px;
  font-size: 28px;
}
@media (max-width: 767px) {
  ::ng-deep ::ng-deep .work-well-slide .disabled {
    margin: 0px;
  }
}
::ng-deep ::ng-deep .media-content {
  position: static;
}
::ng-deep ::ng-deep .media-content .confirmation-box {
  padding: 5px;
  border-top: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  width: 250px;
  clear: both;
  margin-top: 20px;
}
::ng-deep ::ng-deep .media-content .checkbox-circle {
  font-size: 13px;
  font-style: italic;
  float: right;
  margin-right: -23px;
  margin-top: 7px;
}
::ng-deep ::ng-deep .media-content .checkbox-circle label {
  line-height: 1.3em;
}
::ng-deep ::ng-deep .media-content .checkbox-circle label::before {
  margin-left: -19px;
  outline: none;
}
::ng-deep ::ng-deep .media-content .btn-success.btn-outline {
  color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
  max-width: 60%;
  margin: auto;
}
::ng-deep ::ng-deep .media-content .btn-success.btn-outline:hover, ::ng-deep ::ng-deep .media-content .btn-success.btn-outline:active, ::ng-deep ::ng-deep .media-content .btn-success.btn-outline:focus {
  background-color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
  color: #fff;
}
::ng-deep ::ng-deep .media-content .card-description p {
  color: #6d6e71;
}
::ng-deep ::ng-deep .media-content .build-form {
  max-width: 60%;
  width: 100%;
  margin: 10px auto;
}
::ng-deep ::ng-deep .media-content .build-form label {
  display: block;
  width: 100%;
}
::ng-deep ::ng-deep .media-content .build-form label span {
  display: inline-block;
  margin: 2px;
  float: right;
}
::ng-deep ::ng-deep .media-content .build-form label span:hover {
  cursor: pointer;
}
::ng-deep ::ng-deep .media-content .build-form input {
  height: 33px;
  outline: none;
  border: 1px solid #888888;
  width: 100%;
  border-radius: 3px;
  text-indent: 10px;
  margin-bottom: 10px;
}
::ng-deep ::ng-deep .media-content .build-form input:focus {
  border: 1px solid rgb(105, 190, 40);
}
::ng-deep ::ng-deep .media-container .btn-develop {
  border: 1px solid rgb(105, 190, 40);
  background: rgb(105, 190, 40);
}
::ng-deep ::ng-deep .media-container .btn-develop:hover, ::ng-deep ::ng-deep .media-container .btn-develop:active, ::ng-deep ::ng-deep .media-container .btn-develop:focus {
  background-color: #449d44;
  border: 1px solid #449d44;
  color: #fff;
}
::ng-deep ::ng-deep .map-btn {
  /*color: \$develop-color;*/
  /*border-color: \$develop-color;*/
  max-width: 200px;
  margin: 40px auto 0px;
  width: 100%;
  display: block;
}
::ng-deep ::ng-deep .map-btn.btn-develop:hover {
  border: 1px solid #449d44;
  background: #449d44;
}
::ng-deep ::ng-deep .map-btn:hover, ::ng-deep ::ng-deep .map-btn:active, ::ng-deep ::ng-deep .map-btn:focus {
  background-color: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
  color: #fff;
}
::ng-deep ::ng-deep .media-content .btn-develop {
  background: rgb(105, 190, 40);
  border-color: rgb(105, 190, 40);
}
::ng-deep ::ng-deep .media-content .btn-develop:active, ::ng-deep ::ng-deep .media-content .btn-develop:focus, ::ng-deep ::ng-deep .media-content .btn-develop:hover {
  background: #449d44;
  border: 1px solid #449d44;
  color: #fff;
}
::ng-deep ::ng-deep .media-content h2 a.grey-link {
  position: absolute;
  right: 10px;
}
::ng-deep ::ng-deep .map-img {
  margin-top: 45px !important;
}
::ng-deep ::ng-deep .work-modal {
  font-size: 14px;
}
::ng-deep ::ng-deep .work-modal .btn-example {
  display: inline-block;
  cursor: pointer;
}
::ng-deep ::ng-deep .work-modal .work-modal_popup {
  display: none;
}
::ng-deep ::ng-deep .work-modal .work-modal_popup.active {
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}
::ng-deep ::ng-deep .work-modal .work-modal_popup .popup_content {
  position: absolute;
  top: 50%;
  max-width: 600px;
  background: rgba(255, 255, 255, 0.9);
  left: 0;
  right: 0;
  font-size: 18px;
  padding: 20px;
  margin: auto;
  transform: translateY(-50%);
}
::ng-deep ::ng-deep .work-modal .work-modal_popup .popup_content h3 {
  font-size: 24px;
}
::ng-deep ::ng-deep .work-modal .work-modal_popup .popup_content .clx-example {
  position: absolute;
  right: -30px;
  top: -30px;
  display: inline-block;
  font-size: 24px;
  color: #fff;
  cursor: pointer;
}
::ng-deep ::ng-deep .card-description p {
  font-size: 13px;
}
::ng-deep ::ng-deep .card-description p strong {
  display: inline;
  margin-bottom: 5px;
}
::ng-deep ::ng-deep .activeBox {
  color: #48ac51 !important;
}
::ng-deep ::ng-deep .user-profile-wrapper a {
  color: #333;
  text-decoration: underline;
}
::ng-deep ::ng-deep .user-profile-wrapper a:hover, ::ng-deep ::ng-deep .user-profile-wrapper a:focus, ::ng-deep ::ng-deep .user-profile-wrapper a:active {
  color: #333;
  text-decoration: none;
}
::ng-deep ::ng-deep .m-t-xs {
  padding-bottom: 50px;
}
::ng-deep ::ng-deep .nav-header .thumbs img {
  max-width: 60%;
}
::ng-deep ::ng-deep .dashboard-new {
  min-width: 755px;
  max-width: 755px;
  min-height: 525px;
  width: 95%;
  margin: 25px auto 0 auto;
  padding-top: 35px;
}
@media only screen and (max-width: 1023px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep ::ng-deep .dashboard-new {
    min-width: 510px;
  }
}
@media only screen and (max-width: 960px) {
  body.mini-navbar ::ng-deep ::ng-deep .dashboard-new {
    min-width: 510px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep ::ng-deep .dashboard-new {
    min-width: 100% !important;
  }
}
::ng-deep ::ng-deep .dashboard-new h1,
::ng-deep ::ng-deep .dashboard-new p {
  margin: 0;
}
::ng-deep ::ng-deep .dashboard-new .footer-images {
  padding: 25px 20px;
  margin-top: 20%;
  margin-bottom: 25px;
  display: table;
  width: 100%;
}
::ng-deep ::ng-deep .dashboard-new .footer-images .col-xs-6 {
  padding: 0;
  line-height: 29px;
}
::ng-deep ::ng-deep .dashboard-new .footer-images .col-xs-6 img {
  max-width: 100%;
  vertical-align: bottom;
}
@media only screen and (max-width: 767px) {
  ::ng-deep ::ng-deep .dashboard-new .footer-images {
    margin-top: 20px;
  }
}
@media only screen and (min-width: 769px) and (max-width: 960px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep ::ng-deep .dashboard-new h1 {
    margin-top: 25px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep ::ng-deep .dashboard-new h1 {
    margin-top: 25px;
  }
}
@media only screen and (max-width: 600px) {
  ::ng-deep ::ng-deep .dashboard-new h1 {
    font-size: 25px;
    margin-top: 0px;
  }
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block {
  max-width: 670px;
  width: 95%;
  margin: 0 auto;
  padding: 0;
  position: relative;
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul {
  padding: 0;
  margin: -80px 0 0 0;
  list-style: none;
  display: table;
  width: 100%;
  transition: all 300ms ease;
}
@media only screen and (min-width: 769px) and (max-width: 960px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul {
    margin-top: 25px;
    text-align: center;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul {
    margin-top: 25px;
    text-align: center;
  }
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul * {
  transition: all 300ms ease;
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li {
  max-width: 134px;
  min-height: 330px;
  line-height: 330px;
  float: none;
  display: table-cell;
  position: relative;
}
@media only screen and (min-width: 769px) and (max-width: 960px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li {
    display: inline-block;
    width: 50%;
    min-height: 200px;
    line-height: 200px;
    margin-bottom: 25px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li {
    display: inline-block;
    width: 100%;
    max-width: 100%;
    min-height: inherit;
    line-height: inherit;
    margin-bottom: 25px;
  }
  ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li:first-child, ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li:last-child {
    min-height: initial !important;
    line-height: initial !important;
  }
  ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li:last-child {
    margin-bottom: 35px;
  }
}
@media only screen and (max-width: 413px) {
  body.mini-navbar ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li {
    width: 100%;
  }
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li * {
  line-height: normal;
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle {
  display: inline-block;
  vertical-align: bottom;
  background-color: #fab254;
  border-radius: 50%;
  width: 108px;
  height: 108px;
  line-height: 108px;
  text-align: center;
  position: relative;
  -ms-box-shadow: 0px 5px 25px -3px #676a6c;
  -o-box-shadow: 0px 5px 25px -3px #676a6c;
  box-shadow: 0px 5px 25px -3px #676a6c;
  cursor: pointer;
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle:hover, ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle:focus {
  -ms-box-shadow: 0px 0px 20px -3px #676a6c;
  -o-box-shadow: 0px 0px 20px -3px #676a6c;
  box-shadow: 0px 0px 20px -3px #676a6c;
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle:hover .fa, ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle:focus .fa {
  color: #293846;
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle:after {
  content: "";
  border: 1px solid #db6e57;
  width: 50px;
  display: inline-block;
  position: absolute;
  right: -48px;
  top: 40%;
  transform: translate(0%, -50%) rotate(-25deg);
}
@media only screen and (max-width: 767px) {
  ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle:after {
    transform: translate(0%, -50%) rotate(90deg) !important;
    right: 29px !important;
    bottom: -26px;
    top: inherit !important;
  }
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle2 {
  margin-bottom: 20px;
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle2:after {
  right: -48px;
  top: 40%;
  transform: translate(0%, -50%) rotate(-25deg);
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle3 {
  margin-bottom: 60px;
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle3:after {
  right: -42px;
  top: 17%;
  transform: translate(0%, -50%) rotate(-35deg);
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle4 {
  margin-bottom: 140px;
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle4:after {
  right: -42px;
  top: 17%;
  transform: translate(0%, -50%) rotate(-35deg);
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle5 {
  vertical-align: top;
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle5:after {
  content: none;
}
@media only screen and (min-width: 769px) and (max-width: 960px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle {
    vertical-align: top;
  }
  body.dash-admin-3:not(.mini-navbar) ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle:after {
    right: -50px;
    top: 50%;
    transform: translate(0%, -50%) rotate(0deg);
  }
  body.dash-admin-3:not(.mini-navbar) ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle2, body.dash-admin-3:not(.mini-navbar) ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle3, body.dash-admin-3:not(.mini-navbar) ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle4, body.dash-admin-3:not(.mini-navbar) ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle5 {
    margin: 0;
  }
  body.dash-admin-3:not(.mini-navbar) ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle4:after {
    content: none;
  }
  body.dash-admin-3:not(.mini-navbar) ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle5 {
    vertical-align: top;
  }
}
@media only screen and (min-width: 769px) and (max-width: 863px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle3:after {
    content: none;
  }
  body.dash-admin-3:not(.mini-navbar) ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle4:after {
    content: "";
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle {
    vertical-align: top;
  }
  ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle2, ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle3, ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle4, ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle5 {
    margin: 0;
  }
  ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle.circle5 {
    vertical-align: top;
  }
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle a {
  display: inline-block;
  vertical-align: middle;
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle a h4 {
  line-height: 1;
  font-size: 12px;
  color: #000;
  font-family: "MuseoSans-300";
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle a h4 span {
  display: block;
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .circle .fa {
  font-size: 18px !important;
  color: #fff;
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle {
  width: 74px;
  height: 74px;
  line-height: 74px;
  background-color: #db6e57;
  border-radius: 50%;
  text-align: center;
  position: absolute;
  bottom: -71px;
  left: -20px;
  right: 0;
  margin: 0 auto;
  -ms-box-shadow: 0px 3px 10px -3px #676a6c;
  -o-box-shadow: 0px 3px 10px -3px #676a6c;
  box-shadow: 0px 3px 10px -3px #676a6c;
}
@media only screen and (min-width: 769px) and (max-width: 960px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle {
    bottom: 0px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle {
    bottom: -55px;
    left: 0px;
    right: 200px;
  }
}
@media only screen and (max-width: 413px) {
  body.mini-navbar ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle {
    left: 0px !important;
  }
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle:before {
  content: "";
  height: 18px;
  border: 1px solid #db6e57;
  width: 1px;
  margin: 0 auto;
  display: inline-block;
  position: absolute;
  left: 0;
  right: 0;
  top: -17px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle:before {
    height: 45px !important;
    top: -20px !important;
    right: -75px !important;
    transform: rotate(50deg) !important;
    z-index: -1;
  }
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle a {
  display: inline-block;
  vertical-align: middle;
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle a h6 {
  line-height: 1;
  font-size: 11px;
  margin: 0 0 5px 0;
  color: #fff;
  font-family: "MuseoSans-300";
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle a h6 span {
  display: block;
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle .fa {
  font-size: 18px !important;
  color: #fff;
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle2 {
  margin-bottom: 40px;
  left: 20px;
}
@media only screen and (min-width: 769px) and (max-width: 960px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle2 {
    left: 0px;
    margin-bottom: 0;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle2 {
    left: 0px;
    margin-bottom: 0;
  }
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle2:before {
  left: -20px;
  transform: rotate(-20deg);
}
@media only screen and (min-width: 769px) and (max-width: 960px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle2:before {
    left: 0px;
    transform: none;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle2:before {
    left: 0px;
    transform: none;
  }
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle3 {
  margin-bottom: 120px;
  left: 40px;
}
@media only screen and (min-width: 769px) and (max-width: 960px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle3 {
    left: 0px;
    margin-bottom: 0;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle3 {
    left: 0px;
    margin-bottom: 0;
  }
}
::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle3:before {
  left: -30px;
  height: 23px;
  top: -18px;
  transform: rotate(-25deg);
}
@media only screen and (min-width: 769px) and (max-width: 960px) {
  body.dash-admin-3:not(.mini-navbar) ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle3:before {
    left: 0px;
    height: 18px;
    top: -17px;
    transform: none;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep ::ng-deep .dashboard-new .dashboard-inner-block ul li .sub-circle.sub-circle3:before {
    left: 0px;
    height: 18px;
    top: -17px;
    transform: none;
  }
}
::ng-deep ::ng-deep .dash-admin-2 .dashboard-new h1 {
  font-family: "Museo-700";
  color: #fff;
}
::ng-deep ::ng-deep .dash-admin-2 .dashboard-new p {
  color: #fff;
  font-family: "Museo-300";
  font-weight: normal;
}
::ng-deep .icheckbox_square-green,
::ng-deep .iradio_square-green {
  display: inline-block;
  *display: inline;
  vertical-align: middle;
  margin: 0;
  padding: 0;
  width: 22px;
  height: 22px;
  border: none;
  cursor: pointer;
}
::ng-deep .icheckbox_square-green {
  background-position: 0 0;
}
::ng-deep .icheckbox_square-green.hover {
  background-position: -24px 0;
}
::ng-deep .icheckbox_square-green.checked {
  background-position: -48px 0;
}
::ng-deep .icheckbox_square-green.disabled {
  background-position: -72px 0;
  cursor: default;
}
::ng-deep .icheckbox_square-green.checked.disabled {
  background-position: -96px 0;
}
::ng-deep .iradio_square-green {
  background-position: -120px 0;
}
::ng-deep .iradio_square-green.hover {
  background-position: -144px 0;
}
::ng-deep .iradio_square-green.checked {
  background-position: -168px 0;
}
::ng-deep .iradio_square-green.disabled {
  background-position: -192px 0;
  cursor: default;
}
::ng-deep .iradio_square-green.checked.disabled {
  background-position: -216px 0;
}
@media (min-resolution: 120dpi) {
  ::ng-deep .icheckbox_square-green,
  ::ng-deep .iradio_square-green {
    background-size: 240px 24px;
  }
}
::ng-deep ::ng-deep .learner-rating {
  max-width: 230px;
  margin: 0 auto;
  margin-top: 25px;
}
::ng-deep ::ng-deep .learner-rating .inner-learner-rating > div {
  display: inline-block;
  float: left;
  margin: 0 12px;
}
::ng-deep ::ng-deep .learner-rating .text-label {
  margin-left: 10px;
  margin-right: 10px;
  font-size: 12px;
}
::ng-deep ::ng-deep .rating-wrap .build-form {
  max-width: 350px !important;
}
::ng-deep ::ng-deep .rating-wrap .build-form h3 {
  font-size: 16px;
  line-height: 1.2em;
}
::ng-deep ::ng-deep .single-card-link span {
  display: block;
  font-size: 65%;
  text-transform: uppercase;
  padding-top: 8px;
}
::ng-deep .learner-legends li {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep .learner-legends span {
  height: 15px;
  width: 15px;
  border: 1px solid #ccc;
  display: inline-block;
  margin-top: 0px;
  vertical-align: text-top;
  margin-right: 10px;
}
::ng-deep .learner-legends .color-white {
  background: #fff;
}
::ng-deep .learner-legends .color-grey {
  background: rgba(0, 0, 0, 0.2);
}
::ng-deep .legend-header {
  float: left;
  margin-right: 10px;
  margin-top: 36px;
}
::ng-deep ::ng-deep .date-display {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  content: "";
  display: inline-block;
  background: rgba(0, 0, 0, 0.2);
  opacity: 0.5;
  z-index: 0;
}
::ng-deep ::ng-deep .all-learner-maps h4.car-small-heading {
  height: 40px;
  line-height: 23px;
}
::ng-deep ::ng-deep .slide span {
  display: none;
}
::ng-deep ::ng-deep.media-content p {
  display: inline;
}
::ng-deep .media-container.media-main {
  padding-top: 41%;
  min-height: 410px;
}
::ng-deep .html-container {
  max-width: 80%;
  margin: 0 auto;
}
::ng-deep .media-container.media-main .html-container {
  position: absolute;
  top: 0;
  padding: 10px 10px;
  right: 0;
  left: 0;
  max-width: 90%;
  overflow: hidden;
  z-index: 9;
}
::ng-deep .media-container.media-main .html-container:before {
  content: "";
  position: absolute;
  left: -60px;
  top: 0;
  width: 100%;
  height: 120%;
  box-shadow: 22px 0px 0 #8e8e8e inset, 44px 0px 0 #fff inset, 66px 0px 0 #8e8e8e inset, 88px 0px 0 #fff inset, 110px 0px 0 #8e8e8e inset, 132px 0px 0 #fff inset, 154px 0px 0 #8e8e8e inset, 176px 0px 0 #fff inset, 198px 0px 0 #8e8e8e inset, 220px 0px 0 #fff inset, 242px 0px 0 #8e8e8e inset, 264px 0px 0 #fff inset;
  transform: rotate(-45deg);
  z-index: -9;
}
::ng-deep .media-container.media-main .html-container:after {
  content: "";
  position: absolute;
  left: 63px;
  top: -186px;
  width: 100%;
  height: 167%;
  box-shadow: 22px 0px 0 #8e8e8e inset, 44px 0px 0 #fff inset, 66px 0px 0 #8e8e8e inset, 88px 0px 0 #fff inset, 110px 0px 0 #8e8e8e inset, 132px 0px 0 #fff inset, 154px 0px 0 #8e8e8e inset, 176px 0px 0 #fff inset, 198px 0px 0 #8e8e8e inset, 220px 0px 0 #fff inset, 242px 0px 0 #8e8e8e inset, 264px 0px 0 #fff inset, 286px 0px 0 #8e8e8e inset, 308px 0px 0 #fff inset, 330px 0px 0 #8e8e8e inset, 350px 0px 0 #fff inset, 372px 0px 0 #8e8e8e inset, 394px 0px 0 #fff inset;
  transform: rotate(135deg);
  z-index: -9;
}
::ng-deep .media-container.media-main .html-container > div {
  background: #fff;
  padding: 20px 20px;
  position: relative;
}
::ng-deep .media-container.media-main .video-sect-imitation {
  overflow: visible;
}
::ng-deep .media-container.media-main .video-sect-imitation .image-imitation {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
}

::ng-deep.practioner-dash-wrap--ss {
  background: #F1F1F2;
  border-radius: 6px;
  color: #fff;
  padding: 30px 38px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/learner-maps/learner-maps.component.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AA5YA;EAseE,qCAAA;EAEA,yBAAA;EAiGA,cAAA;EAyXA,sCAAA;EAkgBA;uCAAA;EA0DA,kBAAA;AAxmCF;AAlZI;EACE,kBAAA;EACA,kBAAA;AAoZN;AAjZI;EACE,gBAAA;EACA,mBAAA;AAmZN;AAhZI;EACE,eAAA;AAkZN;AA/YI;EACE,eAAA;AAiZN;AA9YI;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,wEAAA;AAgZN;AA7YI;EACE,sBDsCa;ACyWnB;AA5YI;EACE,cAAA;AA8YN;AA1YM;EACE,gBAAA;AA4YR;AAxYI;EACE,UAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EAEA,0BAAA;EACA,2BAAA;AAyYN;AAvYM;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,4BAAA;EACA,wCAAA;EACA,UAAA;AAyYR;AAtYM;EACE,4BAAA;AAwYR;AAnYM;EACE,UAAA;AAqYR;AAjYQ;EACE,WAAA;AAmYV;AA9XQ;EADF;IAEI,gBAAA;EAiYR;AACF;AA7XQ;EACE,eAAA;EACA,gBAAA;AA+XV;AA5XQ;EACE,kBAAA;AA8XV;AA1XM;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AA4XR;AAxXQ;EACE,kBAAA;EACA,aAAA;AA0XV;AAtXM;EACE,kBAAA;EACA,WAAA;EACA,cAAA;AAwXR;AArXM;EAEE,gBAAA;EACA,iBAAA;EACA,aAAA;EAIA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,cD/Fa;ECgGb,eAAA;EACA,4BD7HI;ACgfZ;AAjXQ;EACE,eAAA;EACA,4BDjIE;ACofZ;AAhXQ;EACE,aAAA;AAkXV;AA9WM;EACE,kBAAA;AAgXR;AApWU;EAEE,kBAAA;AAqWZ;AAnWY;EACE,SAAA;AAqWd;AAnWc;EACE,aAAA;AAqWhB;AA/Vc;EACE,cAAA;EACA,WAAA;AAiWhB;AA/VgB;EACE,eAAA;AAiWlB;AA7Vc;EACE,cAAA;EACA,WAAA;AA+VhB;AA7VgB;EACE,kBAAA;AA+VlB;AA1VY;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AA4Vd;AAxVU;EACE,YAAA;EACA,YAAA;EACA,gBAAA;AA0VZ;AAxVY;EACE,eAAA;AA0Vd;AA9TQ;EACE,eAAA;AAgUV;AA5TM;EACE,QAAA;EACA,kBAAA;EACA,UAAA;AA8TR;AA5TQ;EACE,eAAA;AA8TV;AAzTI;EACE,cAAA;AA2TN;AAxTI;EACE,uBDpPK;AC8iBX;AAxTM;EACE,cAAA;AA0TR;AAtTI;EACE,iBAAA;AAwTN;AArTQ;EACE,YAAA;AAuTV;AArTU;EAHF;IAII,qBAAA;IACA,WAAA;IACA,mBAAA;EAwTV;AACF;AAnTI;EACE,qBAAA;AAqTN;AAnTM;EACE,qBAAA;EACA,gBAAA;AAqTR;AAjTI;EACE,eAAA;AAmTN;AAhTI;EACE,eAAA;AAkTN;AA/SI;EACE,+BD5RS;EC6RT,eAAA;AAiTN;AA9SM;EACE,gBAAA;EACA,WAAA;AAgTR;AA7SM;EACE,wED/SK;ECgTL,eAAA;EACA,cAAA;AA+SR;AA1SM;EACE,cAAA;EACA,cAAA;EACA,YAAA;AA4SR;AAxSM;EACE,WAAA;EACA,iBAAA;EACA,oBAAA;AA0SR;AAtSI;EACE,UAAA;EACA,YAAA;EACA,uCAAA;AAwSN;AAtSM;EAEE,YAAA;EACA,mCAAA;AAuSR;AAnSI;EACE,2BAAA;AAqSN;AAlSI;EACE,eAAA;AAoSN;AAjSI;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,cDzTe;EC0Tf,YAAA;EACA,OAAA;EACA,QAAA;EACA,qBAAA;AAmSN;AAjSM;EACE,cAAA;AAmSR;AA/RI;EACE,gBAAA;EACA,mBAAA;AAiSN;AA7RM;EACE,eAAA;AA+RR;AA7RQ;EAHF;IAII,iBAAA;IACA,gBAAA;IACA,gBAAA;EAgSR;AACF;AA9RQ;EATF;IAUI,eAAA;IACA,iBAAA;EAiSR;EA/RQ;IACE,iBAAA;EAiSV;AACF;AA9RQ;EAlBF;IAmBI,4BAAA;IACA,0BAAA;EAiSR;AACF;AA9RM;EACE,eAAA;AAgSR;AA9RQ;EAHF;IAII,eAAA;IACA,WAAA;EAiSR;AACF;AA9RM;EACE,aAAA;AAgSR;AA9RQ;EAHF;IAII,kBAAA;EAiSR;EA/RQ;IACE,eAAA;IACA,kBAAA;IACA,qBAAA;IACA,mBAAA;IACA,YAAA;IACA,uCAAA;IACA,YAAA;EAiSV;AACF;AA7RM;EACE,eAAA;EACA,WD3VW;AC0nBnB;AA7RQ;EACE,YAAA;AA+RV;AA1RI;EACE;IACE,gBAAA;EA4RN;AACF;AAvRI;EAEE;cAAA;AAyRN;AAtRQ;EACE,kBAAA;AAwRV;AArRQ;EALF;IAMI,UAAA;EAwRR;AACF;AAtRQ;EATF;IAUI,WAAA;EAyRR;EAvRQ;IACE,mBAAA;EAyRV;AACF;AApRI;EACE,UAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AAsRN;AApRM;EAPF;IAQI,iBAAA;EAuRN;AACF;AArRM;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;AAuRR;AArRQ;EALF;IAMI,UAAA;IACA,iBAAA;EAwRR;AACF;AAtRQ;EAVF;IAWI,gBAAA;IACA,YAAA;IACA,UAAA;IACA,iBAAA;EAyRR;AACF;AA/QI;EACE,kBAAA;AAiRN;AA7QQ;EACE,YAAA;EACA,mCAAA;AA+QV;AA5QQ;EACE,cAAA;AA8QV;AA1QM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;AA4QR;AAxQU;EACE,YAAA;EACA,mCAAA;AA0QZ;AAxQY;EACE,cAAA;AA0Qd;AAtQU;EACE,cAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;AAwQZ;AAtQY;EANF;IAOI,OAAA;IACA,QAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;IACA,WAAA;EAyQZ;AACF;AAvQY;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,4BAAA;EACA,wCAAA;EACA,UAAA;AAyQd;AAvQc;EACE,YAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,4BAAA;AAyQhB;AA/PI;EACE;IACE,cAAA;IACA,qBAAA;EAiQN;AACF;AA7PE;EACE,4CAAA;EACA,iDAAA;EACA,oDAAA;EAEA,gCAAA;EACA,sBAAA;AA8PJ;AA5PI;EACE,2BAAA;AA8PN;AAjPQ;;EACE,iBAAA;AAoPV;AAlPU;EAHF;;IAII,iBAAA;EAsPV;AACF;AApPU;;EAKE,gBAAA;EACA,cAAA;EACA,WAAA;AAmPZ;AAzPY;;EACE,UAAA;AA4Pd;AArPY;;EACE,eAAA;AAwPd;AArPY;;EACE,kBAAA;AAwPd;AAhPE;EACE,cAAA;EACA,WAAA;EACA,kBAAA;AAkPJ;AA/OE;EACE,gBAAA;AAiPJ;AA/OI;EAHF;IAII,gBAAA;EAkPJ;AACF;AAhPI;EACE,kBAAA;AAkPN;AA/OI;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,8BAAA;EACA,cAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;AAiPN;AA9OI;EACE,WAAA;EACA,2BAAA;AAgPN;AA9OM;EAJF;IAKI,WAAA;IACA,2BAAA;EAiPN;AACF;AA7OE;EACE,kBAAA;EACA,eAAA;AA+OJ;AA7OI;EAJF;IAKI,eAAA;IACA,gBAAA;EAgPJ;AACF;AA9OI;EACE,WAAA;EACA,gBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,8BAAA;EACA,cAAA;EAEA,mCAAA;EACA,kCAAA;AA+ON;AA7OM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AA+OR;AAzOI;EACE,eAAA;AA2ON;AAxOI;EACE,8BAAA;AA0ON;AAxOM;EAHF;IAII,8BAAA;EA2ON;AACF;AAvOI;EACE,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;AAyON;AAvOM;EANF;IAOI,WAAA;EA0ON;AACF;AAtOE;EACE,gBAAA;AAwOJ;AAtOI;EACE,YAAA;EACA,0BAAA;EACA,6BAAA;EAGA,YAAA;EACA,WAAA;EACA,gBAAA;AAsON;AAlOI;EACE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAoON;AAlOM;EACE,kBAAA;AAoOR;AAjOM;EACE,kBAAA;EACA,aAAA;AAmOR;AA/NI;EACE,wBD5tBU;EC6tBV,+BD7tBU;EC8tBV,cAAA;EACA,YAAA;AAiON;AA/NM;EAGE,mCDpuBQ;ECquBR,+BDruBQ;ECsuBR,WDtrBW;ACq5BnB;AA3NI;EAGE,cD5tBe;ACu7BrB;AAxNI;EACE,cAAA;EACA,WAAA;EACA,iBAAA;AA0NN;AAxNM;EACE,cAAA;EACA,WAAA;AA0NR;AAxNQ;EACE,qBAAA;EACA,WAAA;EACA,YAAA;AA0NV;AAxNU;EACE,eAAA;AA0NZ;AArNM;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAuNR;AArNQ;EACE,mCAAA;AAuNV;AA/MI;EACE,mCAAA;EACA,6BDxxBU;ACy+BhB;AA/MM;EAGE,yBAAA;EACA,yBAAA;EACA,WD/uBW;AC87BnB;AA1ME;EACE,yBAAA;EACA,gCAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;AA4MJ;AA1MI;EACE,yBAAA;EACA,mBAAA;AA4MN;AAzMI;EAGE,mCDpzBU;ECqzBV,+BDrzBU;ECszBV,WDtwBa;AC+8BnB;AAnMI;EACE,6BD7zBU;EC8zBV,+BD9zBU;ACmgChB;AAnMM;EAGE,mBAAA;EACA,yBAAA;EACA,WDrxBW;ACw9BnB;AA9LM;EACE,kBAAA;EACA,WAAA;AAgMR;AA3LE;EACE,2BAAA;AA6LJ;AA1LE;EACE,eAAA;AA4LJ;AA1LI;EACE,qBAAA;EACA,eAAA;AA4LN;AAzLI;EACE,aAAA;AA2LN;AAzLM;EACE,cAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;AA2LR;AAxLM;EACE,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,oCAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EAGA,2BAAA;AA0LR;AAxLQ;EACE,eAAA;AA0LV;AAvLQ;EACE,kBAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;EACA,eAAA;EACA,WDn1BS;ECo1BT,eAAA;AAyLV;AAlLI;EACE,eAAA;AAoLN;AAlLM;EACE,eAAA;EACA,kBAAA;AAoLR;AA/KE;EACE,yBAAA;AAiLJ;AA9KE;EACE,WAAA;EACA,0BAAA;AAgLJ;AA9KI;EAGE,WAAA;EACA,qBAAA;AA8KN;AA1KE;EACE,oBAAA;AA4KJ;AAzKE;EACE,cAAA;AA2KJ;AAvKE;EACE,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,wBAAA;EAQA,iBAAA;AAkKJ;AAhKI;EACE;IACE,gBAAA;EAkKN;AACF;AA/JI;EACE;IACE,gBAAA;EAiKN;AACF;AA9JI;EA3BF;IA4BI,0BAAA;EAiKJ;AACF;AA/JI;;EAEE,SAAA;AAiKN;AA3JI;EAEE,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;AA4JN;AA1JM;EACE,UAAA;EACA,iBAAA;AA4JR;AA1JQ;EACE,eAAA;EACA,sBAAA;AA4JV;AAxJM;EAlBF;IAmBI,gBAAA;EA2JN;AACF;AApJM;EACE;IACE,gBAAA;EAsJR;AACF;AAnJM;EATF;IAUI,gBAAA;EAsJN;AACF;AApJM;EAbF;IAcI,eAAA;IACA,eAAA;EAuJN;AACF;AApJI;EACE,gBAAA;EACA,UAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;AAsJN;AApJM;EACE,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EAkBA,0BAAA;AAyIR;AAzJQ;EACE;IACE,gBAAA;IACA,kBAAA;EA2JV;AACF;AAxJQ;EAdF;IAeI,gBAAA;IACA,kBAAA;EA2JR;AACF;AAnJQ;EAKE,0BAAA;AAqJV;AAlJQ;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAoJV;AAlJU;EACE;IACE,qBAAA;IACA,UAAA;IACA,iBAAA;IACA,kBAAA;IACA,mBAAA;EAoJZ;AACF;AAjJU;EAlBF;IAmBI,qBAAA;IACA,WAAA;IACA,eAAA;IAGA,mBAAA;IACA,oBAAA;IACA,mBAAA;EAkJV;EAhJU;IAEE,8BAAA;IACA,+BAAA;EAiJZ;EA9IU;IACE,mBAAA;EAgJZ;AACF;AA7IU;EACE;IACE,WAAA;EA+IZ;AACF;AA5IU;EACE,mBAAA;AA8IZ;AA3IU;EACE,qBAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EAGA,yCAAA;EACA,wCAAA;EACA,qCAAA;EACA,eAAA;AA6IZ;AA3IY;EAIE,yCAAA;EACA,wCAAA;EACA,qCAAA;AA4Id;AA1Ic;EACE,cAAA;AA4IhB;AAxIY;EACE,WAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,6CAAA;AA0Id;AAxIc;EAVF;IAYI,uDAAA;IACA,sBAAA;IACA,aAAA;IACA,uBAAA;EA0Id;AACF;AAvIY;EACE,mBAAA;AAyId;AAvIc;EACE,YAAA;EACA,QAAA;EACA,6CAAA;AAyIhB;AArIY;EACE,mBAAA;AAuId;AArIc;EACE,YAAA;EACA,QAAA;EACA,6CAAA;AAuIhB;AAnIY;EACE,oBAAA;AAqId;AAnIc;EACE,YAAA;EACA,QAAA;EACA,6CAAA;AAqIhB;AAjIY;EACE,mBAAA;AAmId;AAjIc;EACE,aAAA;AAmIhB;AA/HY;EACE;IACE,mBAAA;EAiId;EA/Hc;IACE,YAAA;IACA,QAAA;IACA,2CAAA;EAiIhB;EA9Hc;IAIE,SAAA;EA6HhB;EAzHgB;IACE,aAAA;EA2HlB;EAvHc;IACE,mBAAA;EAyHhB;AACF;AArHY;EAGM;IACE,aAAA;EAqHlB;EAhHgB;IACE,WAAA;EAkHlB;AACF;AA7GY;EApIF;IAqII,mBAAA;EAgHZ;EA9GY;IAIE,SAAA;EA6Gd;EA1GY;IACE,mBAAA;EA4Gd;AACF;AAzGY;EACE,qBAAA;EACA,sBAAA;AA2Gd;AAzGc;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,4BDpwCJ;AC+2CZ;AAzGgB;EACE,cAAA;AA2GlB;AArGY;EACE,0BAAA;EACA,WD/sCK;ACszCnB;AAnGU;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,QAAA;EACA,cAAA;EAGA,yCAAA;EACA,wCAAA;EACA,qCAAA;AAqGZ;AAnGY;EACE;IACE,WAAA;EAqGd;AACF;AAlGY;EAxBF;IAyBI,aAAA;IACA,SAAA;IACA,YAAA;EAqGZ;AACF;AAnGY;EACE;IACE,oBAAA;EAqGd;AACF;AAlGY;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;AAoGd;AAlGc;EAZF;IAaI,uBAAA;IACA,qBAAA;IACA,uBAAA;IACA,mCAAA;IACA,WAAA;EAqGd;AACF;AAlGY;EACE,qBAAA;EACA,sBAAA;AAoGd;AAlGc;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,WDpxCG;ECqxCH,4BDr1CJ;ACy7CZ;AAlGgB;EACE,cAAA;AAoGlB;AA9FY;EACE,0BAAA;EACA,WDhyCK;ACg4CnB;AA7FY;EACE,mBAAA;EACA,UAAA;AA+Fd;AA7Fc;EACE;IACE,SAAA;IACA,gBAAA;EA+FhB;AACF;AA5Fc;EAXF;IAYI,SAAA;IACA,gBAAA;EA+Fd;AACF;AA7Fc;EACE,WAAA;EACA,yBAAA;AA+FhB;AA7FgB;EACE;IACE,SAAA;IACA,eAAA;EA+FlB;AACF;AA5FgB;EAXF;IAYI,SAAA;IACA,eAAA;EA+FhB;AACF;AA3FY;EACE,oBAAA;EACA,UAAA;AA6Fd;AA3Fc;EACE;IACE,SAAA;IACA,gBAAA;EA6FhB;AACF;AA1Fc;EAXF;IAYI,SAAA;IACA,gBAAA;EA6Fd;AACF;AA3Fc;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,yBAAA;AA6FhB;AA3FgB;EACE;IACE,SAAA;IACA,YAAA;IACA,UAAA;IACA,eAAA;EA6FlB;AACF;AA1FgB;EAfF;IAgBI,SAAA;IACA,YAAA;IACA,UAAA;IACA,eAAA;EA6FhB;AACF;AAnFI;EACE,wBDt7CK;ECu7CL,WDr3Ca;AC08CnB;AAlFI;EACE,WDz3Ca;EC03Cb,wBD/7CK;ECg8CL,mBAAA;AAoFN;AA9EE;;EAEE,qBAAA;GAgFF,eA/EE;EACA,sBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EAEA,YAAA;EACA,eAAA;AA+EJ;AA5EE;EACE,wBAAA;AA8EJ;AA3EE;EACE,4BAAA;AA6EJ;AA1EE;EACE,4BAAA;AA4EJ;AAzEE;EACE,4BAAA;EACA,eAAA;AA2EJ;AAxEE;EACE,4BAAA;AA0EJ;AAvEE;EACE,6BAAA;AAyEJ;AAtEE;EACE,6BAAA;AAwEJ;AArEE;EACE,6BAAA;AAuEJ;AApEE;EACE,6BAAA;EACA,eAAA;AAsEJ;AAnEE;EACE,6BAAA;AAqEJ;AAjEE;EAIE;;IAIE,2BAAA;EA+DJ;AACF;AA3DE;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;AA6DJ;AA1DM;EACE,qBAAA;EACA,WAAA;EACA,cAAA;AA4DR;AAxDI;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;AA0DN;AArDI;EACE,2BAAA;AAuDN;AArDM;EACE,eAAA;EACA,kBAAA;AAuDR;AAjDI;EACE,cAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AAmDN;AA7CI;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AA+CN;AA5CI;EACE,YAAA;EACA,WAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,wBAAA;EACA,kBAAA;AA8CN;AA3CI;EACE,gBDlgDa;AC+iDnB;AA1CI;EACE,8BAAA;AA4CN;AAxCE;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;AA0CJ;AAvCE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,qBAAA;EACA,8BAAA;EACA,YAAA;EACA,UAAA;AAyCJ;AAtCE;EACE,YAAA;EACA,iBAAA;AAwCJ;AArCE;EACE,aAAA;AAuCJ;AApCE;EACE,eAAA;AAsCJ;AAnCE;EACE,gBAAA;EACA,iBAAA;AAqCJ;AAlCE;EACE,cAAA;EACA,cAAA;AAoCJ;AAjCE;EACE,kBAAA;EACA,MAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,cAAA;EACA,gBAAA;EACA,UAAA;AAmCJ;AAhCE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,wTAAA;EACA,yBAAA;EACA,WAAA;AAkCJ;AA/BE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,idAAA;EACA,yBAAA;EACA,WAAA;AAiCJ;AA9BE;EACE,gBDxlDe;ECylDf,kBAAA;EACA,kBAAA;AAgCJ;AA7BE;EACE,iBAAA;AA+BJ;AA5BE;EACE,uCAAA;AA8BJ;;AA1BA;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AA6BF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","// Font\n@import './../../../assets/styles/variables';\n\n::ng-deep {\n  ::ng-deep .all-learner-maps {\n\n    // Scroll Bug Fix\n    .modal-open {\n      overflow-x: hidden;\n      overflow-y: scroll;\n    }\n\n    .date-card {\n      margin-top: 60px;\n      margin-bottom: 60px;\n    }\n\n    .arrow-wrapper {\n      font-size: 24px;\n    }\n\n    .clickable {\n      cursor: pointer;\n    }\n\n    .info-label {\n      display: none;\n      position: absolute;\n      left: 5px;\n      top: 5px;\n      font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    }\n\n    .product-imitation {\n      background-color: $color-light-type;\n    }\n\n    .iphone .info-label {\n      display: block;\n    }\n\n    .popover-content {\n      p {\n        padding-top: 5px;\n      }\n    }\n\n    .modal-iphone {\n      top: 132px;\n      left: -3px;\n      display: block;\n      z-index: 1050;\n      padding: 0px;\n      margin-top: 10px;\n\n      max-width: 100% !important;\n      min-width: 200px !important;\n\n      .arrow {\n        left: 50%;\n        margin-left: -11px;\n        border-top-width: 0;\n        border-bottom-color: #999999;\n        border-bottom-color: rgba(0, 0, 0, 0.25);\n        top: -11px;\n      }\n\n      .arrow:after {\n        border-bottom-color: #f7f7f7;\n      }\n    }\n\n    .course-index {\n      .product-desc {\n        padding: 0;\n      }\n\n      .col-md-15 {\n        .col-md-15 {\n          width: 100%;\n        }\n      }\n\n      .common-section-wrap.col-md-15 {\n        @media (min-width: 680px) {\n          max-width: 150px;\n        }\n      }\n\n      .common-section-wrap.row {\n        .lecture-small-box {\n          padding: 0 10px;\n          max-width: 150px;\n        }\n\n        .single-section-wrap {\n          margin-left: 205px;\n        }\n      }\n\n      .product-box .btn-outline {\n        position: absolute;\n        right: 5px;\n        top: 5px;\n      }\n\n      .btn-group {\n        .btn {\n          border-radius: 0px;\n          margin: 0.5px;\n        }\n      }\n\n      .product-box {\n        position: relative;\n        width: 100%;\n        display: table;\n      }\n\n      .product-imitation {\n        //padding: 75px 5px;\n        padding: 0px 5px;\n        max-height: 130px;\n        height: 130px;\n        // display: flex;\n        // align-items: center;\n        // justify-content: center;\n        display: table-cell;\n        vertical-align: middle;\n        text-align: center;\n        width: 100%;\n        color: $body-content-color;\n        font-size: 20px;\n        font-family: $muso-sans;\n\n        h3 {\n          font-size: 20px;\n          font-family: $muso-sans;\n        }\n\n        &:focus {\n          outline: none;\n        }\n      }\n\n      .lecture-small-box {\n        position: relative;\n\n        .over-content {\n          //position: absolute;\n          //right: -416px;\n          //top: -22px;\n          //z-index: 999;\n          //box-shadow: 3px 3px 3px #ccc;\n          //border: 1px solid #1AB394;\n          //transition: all 0.5s ease;\n          //display: none;\n\n          .video-meta-wrapper {\n            //width: 400px;\n            position: relative;\n\n            .ibox {\n              margin: 0;\n\n              .ibox-title {\n                border-top: 0;\n              }\n            }\n\n            .ibox-content {\n\n              .pull-left {\n                max-width: 50%;\n                width: 100%;\n\n                .product-imitation {\n                  padding: 70px 0;\n                }\n              }\n\n              .pull-right {\n                max-width: 45%;\n                width: 100%;\n\n                ul {\n                  padding-left: 20px;\n                }\n              }\n            }\n\n            .stat-percent {\n              position: absolute;\n              bottom: 5px;\n              right: 5px;\n            }\n          }\n\n          .product-imitation {\n            padding: 0px;\n            height: auto;\n            max-height: 100%;\n\n            img {\n              max-width: 100%;\n            }\n          }\n        }\n\n        .over-content:after {\n          //content: '';\n          //display: block;\n          //position: absolute;\n          //right: 100%;\n          //top: 50%;\n          //margin-top: -15px;\n          //width: 0;\n          //height: 0;\n          //border-top: 15px solid transparent;\n          //border-right: 15px solid $color-light-type;\n          //border-bottom: 15px solid transparent;\n          //border-left: 15px solid transparent;\n        }\n      }\n\n      .lecture-small-box:hover {\n        .over-content {\n          //display: block;\n        }\n      }\n\n      .arrow-icons {\n        .fa {\n          font-size: 24px;\n        }\n      }\n\n      .lecture-state {\n        top: 5px;\n        position: absolute;\n        right: 6px;\n\n        .text-green {\n          font-size: 19px;\n        }\n      }\n    }\n\n    .text-green {\n      color: #48ac51;\n    }\n\n    .car-small-heading {\n      font-family: $car-font;\n\n      a {\n        color: inherit;\n      }\n    }\n\n    .practioner-dash-wrap {\n      margin-top: -43px;\n\n      &.cols-4 {\n        .col-sm-3 {\n          width: 180px;\n\n          @media screen and (max-width: 991px) {\n            display: inline-block;\n            float: none;\n            vertical-align: top;\n          }\n        }\n      }\n    }\n\n    .inline-profile {\n      display: inline-block;\n\n      .profile_types {\n        display: inline-block;\n        margin-left: 0px;\n      }\n    }\n\n    h3.car-small-heading {\n      font-size: 20px;\n    }\n\n    h4.car-small-heading {\n      font-size: 18px;\n    }\n\n    .car-big-heading {\n      font-family: $car-big-font;\n      font-size: 50px;\n      //margin-top: -16px;\n\n      img {\n        max-width: 550px;\n        width: 100%;\n      }\n\n      small {\n        font-family: $font-stack;\n        font-size: 23px;\n        display: block;\n      }\n    }\n\n    .course-index {\n      >h2 {\n        margin: 0 auto;\n        display: table;\n        width: 563px;\n        //text-align: left;\n      }\n\n      >hr {\n        clear: both;\n        padding-top: 20px;\n        padding-bottom: 20px;\n      }\n    }\n\n    .product-box {\n      padding: 0;\n      border: none;\n      box-shadow: 10px 10px 10px -3px $body-content-color;\n\n      &:hover,\n      &:active {\n        border: none;\n        box-shadow: 3px 3px 7px 0px #a8a8a8;\n      }\n    }\n\n    .dashboard-wrapper .car-big-heading img {\n      max-width: 325px !important;\n    }\n\n    .practioner-dash-wrap {\n      margin-top: 0px;\n    }\n\n    .icon-btn {\n      position: absolute;\n      bottom: 5px;\n      font-size: 22px;\n      color: $body-content-color;\n      margin: auto;\n      left: 0;\n      right: 0;\n      display: inline-block;\n\n      &:hover {\n        color: #48ac51;\n      }\n    }\n\n    .fs-logo-feedback {\n      max-width: 350px;\n      margin: 30px auto 0;\n    }\n\n    #f-implement1 {\n      .profile-description {\n        font-size: 15px;\n\n        @media(max-width:960px) {\n          max-height: 245px;\n          overflow: hidden;\n          overflow-y: auto;\n        }\n\n        @media(max-width:767px) {\n          font-size: 12px;\n          max-height: 310px;\n\n          body.mini-navbar & {\n            max-height: 302px;\n          }\n        }\n\n        @media only screen and (max-height: 414px) and (orientation:landscape) {\n          max-height: 115px !important;\n          font-size: 13px !important;\n        }\n      }\n\n      .fix-label {\n        font-size: 23px;\n\n        @media(max-width:767px) {\n          font-size: 16px;\n          float: left;\n        }\n      }\n\n      .about-u {\n        padding: 10px;\n\n        @media(max-width:767px) {\n          margin-bottom: 5px;\n\n          .right-label-text {\n            font-size: 16px;\n            margin-bottom: 0px;\n            display: inline-block;\n            vertical-align: top;\n            padding: 7px;\n            background: $clarify-color !important;\n            float: right;\n          }\n        }\n      }\n\n      .right-label-text {\n        font-size: 18px;\n        color: $color-light-type;\n\n        span {\n          padding: 8px;\n        }\n      }\n    }\n\n    @media (min-width: 680px) {\n      .new-dashboard .col-sm-3 {\n        max-width: 180px;\n      }\n    }\n  }\n\n  ::ng-deep .page-heading {\n    .col-lg-10 {\n\n      /*float: left;\n      width: 75%;*/\n      &.header-full {\n        h2 {\n          padding-right: 0px;\n        }\n\n        @media only screen and (min-width:769px) {\n          width: 60%;\n        }\n\n        @media only screen and (max-width:768px) {\n          width: 100%;\n\n          h2 {\n            padding-right: 50px;\n          }\n        }\n      }\n    }\n\n    .header-back {\n      width: 25%;\n      float: left;\n      text-align: right;\n      padding-right: 0;\n      padding-top: 30px;\n\n      @media only screen and (max-width:768px) {\n        padding-top: 50px;\n      }\n\n      &.full-screen-option {\n        width: 100%;\n        padding-top: 10px;\n        padding-right: 15px;\n\n        @media only screen and (min-width:769px) {\n          width: 40%;\n          padding-top: 30px;\n        }\n\n        @media only screen and (max-height:736px) and (orientation:landscape) {\n          padding-top: 0px;\n          float: right;\n          width: 50%;\n          margin-top: -20px;\n        }\n      }\n    }\n  }\n\n  /*===== learner map css ============*/\n\n  /* Style-for leaner-map */\n\n  ::ng-deep .course-index {\n    .ibox {\n      position: relative;\n\n      &:hover {\n\n        .product-box {\n          border: none;\n          box-shadow: 3px 3px 7px 0px #a8a8a8;\n        }\n\n        .icon-btn {\n          color: #48ac51;\n        }\n      }\n\n      input[type=checkbox] {\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        opacity: 0;\n        cursor: pointer;\n        z-index: 1;\n\n        &:checked {\n\n          ~div.product-box {\n            border: none;\n            box-shadow: 3px 3px 7px 0px #a8a8a8;\n\n            a.icon-btn {\n              color: #48ac51;\n            }\n          }\n\n          ~div.popover {\n            display: block;\n            top: 130px;\n            left: -100px;\n            margin-top: 15px;\n\n            @media screen and (max-width: 679px) {\n              left: 0;\n              right: 0;\n              margin-left: auto;\n              margin-right: auto;\n              max-width: 350px;\n              min-width: auto;\n              width: 100%;\n            }\n\n            >.arrow {\n              left: 50%;\n              margin-left: -11px;\n              border-top-width: 0;\n              border-bottom-color: #999999;\n              border-bottom-color: rgba(0, 0, 0, 0.25);\n              top: -11px;\n\n              &:after {\n                content: \" \";\n                top: 1px;\n                margin-left: -10px;\n                border-top-width: 0;\n                border-bottom-color: #f7f7f7;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  ::ng-deep .cta-wrapper {\n    @media only screen and (max-width: 1400px) {\n      .list-group-item span {\n        max-width: 53%;\n        word-wrap: break-word;\n      }\n    }\n  }\n\n  ::ng-deep .img-shadow {\n    box-shadow: inset 0 0 8px rgba(0, 0, 0, .6);\n    -moz-box-shadow: inset 0 0 8px rgba(0, 0, 0, .6);\n    -webkit-box-shadow: inset 0 0 8px rgba(0, 0, 0, .6);\n\n    background-size: 100% !important;\n    background-position: 0;\n\n    .build-form {\n      margin-top: 30px !important;\n    }\n  }\n\n  /* box-detail*/\n\n  ::ng-deep .dash-practitioner-wrapper,\n  .wrapper-learner-map {\n\n    ::ng-deep .ibox.product-detail {\n\n      .ibox-content {\n\n        .image-imitation {\n          min-height: 642px;\n\n          @media only screen and (max-width: 1400px) {\n            min-height: 350px;\n          }\n\n          .build-form {\n            input[type=\"email\"] {\n              width: 90%;\n            }\n\n            max-width: 300px;\n            margin: 0 auto;\n            float: none;\n\n            .fa {\n              cursor: pointer;\n            }\n\n            fieldset {\n              margin-bottom: 5px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  ::ng-deep span.spacer {\n    display: block;\n    clear: both;\n    margin-bottom: 8px;\n  }\n\n  ::ng-deep .media-container.media-main {\n    padding-top: 41%;\n\n    @media only screen and (max-width: 991px) {\n      padding-top: 61%;\n    }\n\n    .img-shadow {\n      position: absolute;\n    }\n\n    .video-sect-imitation {\n      width: 100%;\n      position: absolute;\n      left: 0;\n      top: 50%;\n      min-height: inherit !important;\n      overflow: auto;\n      transform: translateY(-50%);\n      -webkit-transform: translateY(-50%);\n      -moz-transform: translateY(-50%);\n    }\n\n    .video-sect-imitation {\n      height: 69%;\n      margin: -12.5% 0 !important;\n\n      @media only screen and (max-width: 991px) {\n        height: 92%;\n        margin: -10.5% 0 !important;\n      }\n    }\n  }\n\n  ::ng-deep .media-container {\n    position: relative;\n    padding-top: 0%;\n\n    @media only screen and (max-width: 991px) {\n      padding-top: 0%;\n      margin: 15px 0px;\n    }\n\n    .image-imitation {\n      width: 100%;\n      position: static;\n      left: 0;\n      top: 0;\n      height: 100%;\n      min-height: inherit !important;\n      overflow: auto;\n\n      background-size: contain !important;\n      background-position: center center;\n\n      iframe {\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        left: 0;\n        top: 0;\n      }\n    }\n  }\n\n  ::ng-deep .work-well-slide {\n    h3 {\n      font-size: 22px;\n    }\n\n    .title-sm {\n      margin-bottom: 50px !important;\n\n      @media(max-width: 767px) {\n        margin-bottom: 25px !important;\n      }\n\n    }\n\n    .disabled {\n      height: 50px;\n      vertical-align: middle;\n      margin-top: 35px;\n      font-size: 28px;\n\n      @media(max-width: 767px) {\n        margin: 0px;\n      }\n    }\n  }\n\n  ::ng-deep .media-content {\n    position: static;\n\n    .confirmation-box {\n      padding: 5px;\n      border-top: 1px solid $color-neutral-mid;\n      border-bottom: 1px solid $color-neutral-mid;\n      //position: absolute;\n      //bottom: 10px;\n      width: 250px;\n      clear: both;\n      margin-top: 20px;\n    }\n\n\n    .checkbox-circle {\n      font-size: 13px;\n      font-style: italic;\n      float: right;\n      margin-right: -23px;\n      margin-top: 7px;\n\n      label {\n        line-height: 1.3em;\n      }\n\n      label::before {\n        margin-left: -19px;\n        outline: none;\n      }\n    }\n\n    .btn-success.btn-outline {\n      color: $develop-color;\n      border-color: $develop-color;\n      max-width: 60%;\n      margin: auto;\n\n      &:hover,\n      &:active,\n      &:focus {\n        background-color: $develop-color;\n        border-color: $develop-color;\n        color: $color-light-type;\n      }\n    }\n\n    .card-description p {\n      //font-size: 16px;\n      //line-height: 24px;\n      color: $color-neutral-dark;\n    }\n\n    .build-form {\n      max-width: 60%;\n      width: 100%;\n      margin: 10px auto;\n\n      label {\n        display: block;\n        width: 100%;\n\n        span {\n          display: inline-block;\n          margin: 2px;\n          float: right;\n\n          &:hover {\n            cursor: pointer;\n          }\n        }\n      }\n\n      input {\n        height: 33px;\n        outline: none;\n        border: 1px solid #888888;\n        width: 100%;\n        border-radius: 3px;\n        text-indent: 10px;\n        margin-bottom: 10px;\n\n        &:focus {\n          border: 1px solid $develop-color\n        }\n      }\n    }\n  }\n\n  ::ng-deep .media-container {\n\n    .btn-develop {\n      border: 1px solid $develop-color;\n      background: $develop-color;\n\n      &:hover,\n      &:active,\n      &:focus {\n        background-color: #449d44;\n        border: 1px solid #449d44;\n        color: $color-light-type;\n      }\n    }\n  }\n\n  ::ng-deep .map-btn {\n    /*color: $develop-color;*/\n    /*border-color: $develop-color;*/\n    max-width: 200px;\n    margin: 40px auto 0px;\n    width: 100%;\n    display: block;\n\n    &.btn-develop:hover {\n      border: 1px solid #449d44;\n      background: #449d44;\n    }\n\n    &:hover,\n    &:active,\n    &:focus {\n      background-color: $develop-color;\n      border-color: $develop-color;\n      color: $color-light-type;\n    }\n  }\n\n  ::ng-deep .media-content {\n\n    .btn-develop {\n      background: $develop-color;\n      border-color: $develop-color;\n\n      &:active,\n      &:focus,\n      &:hover {\n        background: #449d44;\n        border: 1px solid #449d44;\n        color: $color-light-type;\n      }\n    }\n\n    h2 {\n      a.grey-link {\n        position: absolute;\n        right: 10px;\n      }\n    }\n  }\n\n  ::ng-deep .map-img {\n    margin-top: 45px !important;\n  }\n\n  ::ng-deep .work-modal {\n    font-size: 14px;\n\n    .btn-example {\n      display: inline-block;\n      cursor: pointer;\n    }\n\n    .work-modal_popup {\n      display: none;\n\n      &.active {\n        display: block;\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: rgba(0, 0, 0, .5);\n        z-index: 9999;\n      }\n\n      .popup_content {\n        position: absolute;\n        top: 50%;\n        max-width: 600px;\n        background: rgba(255, 255, 255, .9);\n        left: 0;\n        right: 0;\n        font-size: 18px;\n        padding: 20px;\n        margin: auto;\n        -webkit-transform: translateY(-50%);\n        -ms-transform: translateY(-50%);\n        transform: translateY(-50%);\n\n        h3 {\n          font-size: 24px;\n        }\n\n        .clx-example {\n          position: absolute;\n          right: -30px;\n          top: -30px;\n          display: inline-block;\n          font-size: 24px;\n          color: $color-light-type;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n\n  ::ng-deep .card-description {\n    p {\n      font-size: 13px;\n      \n      strong {\n        display: inline;\n        margin-bottom: 5px;\n      }\n    }\n  }\n\n  ::ng-deep .activeBox {\n    color: #48ac51 !important;\n  }\n\n  ::ng-deep .user-profile-wrapper a {\n    color: #333;\n    text-decoration: underline;\n\n    &:hover,\n    &:focus,\n    &:active {\n      color: #333;\n      text-decoration: none;\n    }\n  }\n\n  ::ng-deep .m-t-xs {\n    padding-bottom: 50px;\n  }\n\n  ::ng-deep .nav-header .thumbs img {\n    max-width: 60%;\n  }\n\n  /*--- dashboard-new circles style ---*/\n  ::ng-deep .dashboard-new {\n    min-width: 755px;\n    max-width: 755px;\n    min-height: 525px;\n    width: 95%;\n    margin: 25px auto 0 auto;\n    // background-color: rgba(255,255,255,0.85);\n    // -webkit-box-shadow: 0px 1px 8px -5px $body-content-color;\n    // -moz-box-shadow: 0px 1px 8px -5px $body-content-color;\n    // -ms-box-shadow: 0px 1px 8px -5px $body-content-color;\n    // -o-box-shadow: 0px 1px 8px -5px $body-content-color;\n    // box-shadow: 0px 1px 8px -5px $body-content-color;\n    // border: 1px solid $border-color;\n    padding-top: 35px;\n\n    @media only screen and (max-width:1023px) {\n      body.dash-admin-3:not(.mini-navbar) & {\n        min-width: 510px;\n      }\n    }\n\n    @media only screen and (max-width:960px) {\n      body.mini-navbar & {\n        min-width: 510px;\n      }\n    }\n\n    @media only screen and (max-width:767px) {\n      min-width: 100% !important;\n    }\n\n    h1,\n    p {\n      margin: 0;\n      // color: $text-color;\n      // font-family: $muso-sans;\n      // font-weight: bold;\n    }\n\n    .footer-images {\n      //background-color: $light-gray;\n      padding: 25px 20px;\n      margin-top: 20%;\n      margin-bottom: 25px;\n      display: table;\n      width: 100%;\n\n      .col-xs-6 {\n        padding: 0;\n        line-height: 29px;\n\n        img {\n          max-width: 100%;\n          vertical-align: bottom;\n        }\n      }\n\n      @media only screen and (max-width:767px) {\n        margin-top: 20px;\n      }\n\n    }\n\n    h1 {\n      //margin-top: 55px;\n\n      @media only screen and (min-width:769px) and (max-width:960px) {\n        body.dash-admin-3:not(.mini-navbar) & {\n          margin-top: 25px;\n        }\n      }\n\n      @media only screen and (max-width:767px) {\n        margin-top: 25px;\n      }\n\n      @media only screen and (max-width:600px) {\n        font-size: 25px;\n        margin-top: 0px;\n      }\n    }\n\n    .dashboard-inner-block {\n      max-width: 670px;\n      width: 95%;\n      margin: 0 auto;\n      padding: 0;\n      position: relative;\n\n      ul {\n        padding: 0;\n        margin: -80px 0 0 0;\n        list-style: none;\n        display: table;\n        width: 100%;\n\n        @media only screen and (min-width:769px) and (max-width:960px) {\n          body.dash-admin-3:not(.mini-navbar) & {\n            margin-top: 25px;\n            text-align: center;\n          }\n        }\n\n        @media only screen and (max-width:767px) {\n          margin-top: 25px;\n          text-align: center;\n        }\n\n        -webkit-transition:all 300ms ease;\n        -moz-transition:all 300ms ease;\n        -ms-transition:all 300ms ease;\n        -o-transition:all 300ms ease;\n        transition:all 300ms ease;\n\n        * {\n          -webkit-transition: all 300ms ease;\n          -moz-transition: all 300ms ease;\n          -ms-transition: all 300ms ease;\n          -o-transition: all 300ms ease;\n          transition: all 300ms ease;\n        }\n\n        li {\n          max-width: 134px;\n          min-height: 330px;\n          line-height: 330px;\n          float: none;\n          display: table-cell;\n          position: relative;\n\n          @media only screen and (min-width:769px) and (max-width:960px) {\n            body.dash-admin-3:not(.mini-navbar) & {\n              display: inline-block;\n              width: 50%;\n              min-height: 200px;\n              line-height: 200px;\n              margin-bottom: 25px;\n            }\n          }\n\n          @media only screen and (max-width:767px) {\n            display: inline-block;\n            width: 100%;\n            max-width: 100%;\n            // min-height: 200px;\n            // line-height: 200px;\n            min-height: inherit;\n            line-height: inherit;\n            margin-bottom: 25px;\n\n            &:first-child,\n            &:last-child {\n              min-height: initial !important;\n              line-height: initial !important;\n            }\n\n            &:last-child {\n              margin-bottom: 35px;\n            }\n          }\n\n          @media only screen and (max-width:413px) {\n            body.mini-navbar & {\n              width: 100%;\n            }\n          }\n\n          * {\n            line-height: normal;\n          }\n\n          .circle {\n            display: inline-block;\n            vertical-align: bottom;\n            background-color: #fab254;\n            border-radius: 50%;\n            width: 108px;\n            height: 108px;\n            line-height: 108px;\n            text-align: center;\n            position: relative;\n            -webkit-box-shadow: 0px 5px 25px -3px $body-content-color;\n            -moz-box-shadow: 0px 5px 25px -3px $body-content-color;\n            -ms-box-shadow: 0px 5px 25px -3px $body-content-color;\n            -o-box-shadow: 0px 5px 25px -3px $body-content-color;\n            box-shadow: 0px 5px 25px -3px $body-content-color;\n            cursor: pointer;\n\n            &:hover,\n            &:focus {\n              -webkit-box-shadow: 0px 0px 20px -3px $body-content-color;\n              -moz-box-shadow: 0px 0px 20px -3px $body-content-color;\n              -ms-box-shadow: 0px 0px 20px -3px $body-content-color;\n              -o-box-shadow: 0px 0px 20px -3px $body-content-color;\n              box-shadow: 0px 0px 20px -3px $body-content-color;\n\n              .fa {\n                color: #293846;\n              }\n            }\n\n            &:after {\n              content: \"\";\n              border: 1px solid #db6e57;\n              width: 50px;\n              display: inline-block;\n              position: absolute;\n              right: -48px;\n              top: 40%;\n              transform: translate(0%, -50%) rotate(-25deg);\n\n              @media only screen and (max-width:767px) {\n                //content: none;\n                transform: translate(0%, -50%) rotate(90deg) !important;\n                right: 29px !important;\n                bottom: -26px;\n                top: inherit !important;\n              }\n            }\n\n            &.circle2 {\n              margin-bottom: 20px;\n\n              &:after {\n                right: -48px;\n                top: 40%;\n                transform: translate(0%, -50%) rotate(-25deg);\n              }\n            }\n\n            &.circle3 {\n              margin-bottom: 20px * 3;\n\n              &:after {\n                right: -42px;\n                top: 17%;\n                transform: translate(0%, -50%) rotate(-35deg);\n              }\n            }\n\n            &.circle4 {\n              margin-bottom: 20px * 7;\n\n              &:after {\n                right: -42px;\n                top: 17%;\n                transform: translate(0%, -50%) rotate(-35deg);\n              }\n            }\n\n            &.circle5 {\n              vertical-align: top;\n\n              &:after {\n                content: none;\n              }\n            }\n\n            @media only screen and (min-width:769px) and (max-width:960px) {\n              body.dash-admin-3:not(.mini-navbar) & {\n                vertical-align: top;\n\n                &:after {\n                  right: -50px;\n                  top: 50%;\n                  transform: translate(0%, -50%) rotate(0deg);\n                }\n\n                &.circle2,\n                &.circle3,\n                &.circle4,\n                &.circle5 {\n                  margin: 0;\n                }\n\n                &.circle4 {\n                  &:after {\n                    content: none;\n                  }\n                }\n\n                &.circle5 {\n                  vertical-align: top;\n                }\n              }\n            }\n\n            @media only screen and (min-width:769px) and (max-width:863px) {\n              body.dash-admin-3:not(.mini-navbar) & {\n                &.circle3 {\n                  &:after {\n                    content: none;\n                  }\n                }\n\n                &.circle4 {\n                  &:after {\n                    content: \"\";\n                  }\n                }\n              }\n            }\n\n            @media only screen and (max-width:767px) {\n              vertical-align: top;\n\n              &.circle2,\n              &.circle3,\n              &.circle4,\n              &.circle5 {\n                margin: 0;\n              }\n\n              &.circle5 {\n                vertical-align: top;\n              }\n            }\n\n            a {\n              display: inline-block;\n              vertical-align: middle;\n\n              h4 {\n                line-height: 1;\n                font-size: 12px;\n                color: #000;\n                font-family: $muso-sans;\n\n                span {\n                  display: block;\n                  // text-transform: uppercase;\n                }\n              }\n            }\n\n            .fa {\n              font-size: 18px !important;\n              color: $color-light-type;\n            }\n          }\n\n          .sub-circle {\n            width: 74px;\n            height: 74px;\n            line-height: 74px;\n            background-color: #db6e57;\n            border-radius: 50%;\n            text-align: center;\n            position: absolute;\n            bottom: -71px;\n            left: -20px;\n            right: 0;\n            margin: 0 auto;\n            -webkit-box-shadow: 0px 3px 10px -3px $body-content-color;\n            -moz-box-shadow: 0px 3px 10px -3px $body-content-color;\n            -ms-box-shadow: 0px 3px 10px -3px $body-content-color;\n            -o-box-shadow: 0px 3px 10px -3px $body-content-color;\n            box-shadow: 0px 3px 10px -3px $body-content-color;\n\n            @media only screen and (min-width:769px) and (max-width:960px) {\n              body.dash-admin-3:not(.mini-navbar) & {\n                bottom: 0px;\n              }\n            }\n\n            @media only screen and (max-width:767px) {\n              bottom: -55px;\n              left: 0px;\n              right: 200px;\n            }\n\n            @media only screen and (max-width:413px) {\n              body.mini-navbar & {\n                left: 0px !important;\n              }\n            }\n\n            &:before {\n              content: \"\";\n              height: 18px;\n              border: 1px solid #db6e57;\n              width: 1px;\n              margin: 0 auto;\n              display: inline-block;\n              position: absolute;\n              left: 0;\n              right: 0;\n              top: -17px;\n\n              @media only screen and (max-width:767px) {\n                height: 45px !important;\n                top: -20px !important;\n                right: -75px !important;\n                transform: rotate(50deg) !important;\n                z-index: -1;\n              }\n            }\n\n            a {\n              display: inline-block;\n              vertical-align: middle;\n\n              h6 {\n                line-height: 1;\n                font-size: 11px;\n                margin: 0 0 5px 0;\n                color: $color-light-type;\n                font-family: $muso-sans;\n\n                span {\n                  display: block;\n                  // text-transform: uppercase;\n                }\n              }\n            }\n\n            .fa {\n              font-size: 18px !important;\n              color: $color-light-type;\n            }\n\n            &.sub-circle2 {\n              margin-bottom: 40px;\n              left: 20px;\n\n              @media only screen and (min-width:769px) and (max-width:960px) {\n                body.dash-admin-3:not(.mini-navbar) & {\n                  left: 0px;\n                  margin-bottom: 0;\n                }\n              }\n\n              @media only screen and (max-width:767px) {\n                left: 0px;\n                margin-bottom: 0;\n              }\n\n              &:before {\n                left: -20px;\n                transform: rotate(-20deg);\n\n                @media only screen and (min-width:769px) and (max-width:960px) {\n                  body.dash-admin-3:not(.mini-navbar) & {\n                    left: 0px;\n                    transform: none;\n                  }\n                }\n\n                @media only screen and (max-width:767px) {\n                  left: 0px;\n                  transform: none;\n                }\n              }\n            }\n\n            &.sub-circle3 {\n              margin-bottom: 120px;\n              left: 40px;\n\n              @media only screen and (min-width:769px) and (max-width:960px) {\n                body.dash-admin-3:not(.mini-navbar) & {\n                  left: 0px;\n                  margin-bottom: 0;\n                }\n              }\n\n              @media only screen and (max-width:767px) {\n                left: 0px;\n                margin-bottom: 0;\n              }\n\n              &:before {\n                left: -30px;\n                height: 23px;\n                top: -18px;\n                transform: rotate(-25deg);\n\n                @media only screen and (min-width:769px) and (max-width:960px) {\n                  body.dash-admin-3:not(.mini-navbar) & {\n                    left: 0px;\n                    height: 18px;\n                    top: -17px;\n                    transform: none;\n                  }\n                }\n\n                @media only screen and (max-width:767px) {\n                  left: 0px;\n                  height: 18px;\n                  top: -17px;\n                  transform: none;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  ::ng-deep .dash-admin-2 {\n    .dashboard-new h1 {\n      font-family: $muso-700;\n      color: $color-light-type;\n    }\n\n    .dashboard-new p {\n      color: $color-light-type;\n      font-family: $muso-300;\n      font-weight: normal;\n    }\n  }\n\n  /* iCheck plugin Square skin, green\n  ----------------------------------- */\n  .icheckbox_square-green,\n  .iradio_square-green {\n    display: inline-block;\n    *display: inline;\n    vertical-align: middle;\n    margin: 0;\n    padding: 0;\n    width: 22px;\n    height: 22px;\n    //background: url(green.png) no-repeat;\n    border: none;\n    cursor: pointer;\n  }\n\n  .icheckbox_square-green {\n    background-position: 0 0;\n  }\n\n  .icheckbox_square-green.hover {\n    background-position: -24px 0;\n  }\n\n  .icheckbox_square-green.checked {\n    background-position: -48px 0;\n  }\n\n  .icheckbox_square-green.disabled {\n    background-position: -72px 0;\n    cursor: default;\n  }\n\n  .icheckbox_square-green.checked.disabled {\n    background-position: -96px 0;\n  }\n\n  .iradio_square-green {\n    background-position: -120px 0;\n  }\n\n  .iradio_square-green.hover {\n    background-position: -144px 0;\n  }\n\n  .iradio_square-green.checked {\n    background-position: -168px 0;\n  }\n\n  .iradio_square-green.disabled {\n    background-position: -192px 0;\n    cursor: default;\n  }\n\n  .iradio_square-green.checked.disabled {\n    background-position: -216px 0;\n  }\n\n  /* HiDPI support */\n  @media (-o-min-device-pixel-ratio: 5/4),\n  (-webkit-min-device-pixel-ratio: 1.25),\n  (min-resolution: 120dpi) {\n\n    .icheckbox_square-green,\n    .iradio_square-green {\n      //background-image: url(green@2x.png);\n      -webkit-background-size: 240px 24px;\n      background-size: 240px 24px;\n    }\n  }\n\n\n  ::ng-deep .learner-rating {\n    max-width: 230px;\n    margin: 0 auto;\n    margin-top: 25px;\n\n    .inner-learner-rating {\n      &>div {\n        display: inline-block;\n        float: left;\n        margin: 0 12px;\n      }\n    }\n\n    .text-label {\n      margin-left: 10px;\n      margin-right: 10px;\n      font-size: 12px;\n    }\n  }\n\n  ::ng-deep .rating-wrap {\n    .build-form {\n      max-width: 350px !important;\n\n      h3 {\n        font-size: 16px;\n        line-height: 1.2em;\n      }\n    }\n  }\n\n  ::ng-deep .single-card-link {\n    span {\n      display: block;\n      font-size: 65%;\n      text-transform: uppercase;\n      padding-top: 8px;\n    }\n  }\n\n  .learner-legends {\n\n    li {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n    }\n\n    span {\n      height: 15px;\n      width: 15px;\n      border: 1px solid $color-neutral-mid;\n      display: inline-block;\n      margin-top: 0px;\n      vertical-align: text-top;\n      margin-right: 10px;\n    }\n\n    .color-white {\n      background: $color-light-type;\n    }\n\n    .color-grey {\n      background: rgba(0, 0, 0, 0.2);\n    }\n  }\n\n  .legend-header {\n    float: left;\n    margin-right: 10px;\n    margin-top: 36px;\n  }\n\n  ::ng-deep .date-display {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    content: \"\";\n    display: inline-block;\n    background: rgba(0, 0, 0, 0.2);\n    opacity: 0.5;\n    z-index: 0;\n  }\n\n  ::ng-deep .all-learner-maps h4.car-small-heading {\n    height: 40px;\n    line-height: 23px;\n  }\n\n  ::ng-deep .slide span {\n    display: none;\n  }\n\n  ::ng-deep.media-content p {\n    display: inline;\n  }\n\n  .media-container.media-main {\n    padding-top: 41%;\n    min-height: 410px;\n  }\n\n  .html-container {\n    max-width: 80%;\n    margin: 0 auto;\n  }\n\n  .media-container.media-main .html-container {\n    position: absolute;\n    top: 0;\n    padding: 10px 10px;\n    right: 0;\n    left: 0;\n    max-width: 90%;\n    overflow: hidden;\n    z-index: 9;\n  }\n\n  .media-container.media-main .html-container:before {\n    content: \"\";\n    position: absolute;\n    left: -60px;\n    top: 0;\n    width: 100%;\n    height: 120%;\n    box-shadow: 22px 0px 0 #8e8e8e inset, 44px 0px 0 $color-light-type inset, 66px 0px 0 #8e8e8e inset, 88px 0px 0 $color-light-type inset, 110px 0px 0 #8e8e8e inset, 132px 0px 0 $color-light-type inset, 154px 0px 0 #8e8e8e inset, 176px 0px 0 $color-light-type inset, 198px 0px 0 #8e8e8e inset, 220px 0px 0 $color-light-type inset, 242px 0px 0 #8e8e8e inset, 264px 0px 0 $color-light-type inset;\n    transform: rotate(-45deg);\n    z-index: -9;\n  }\n\n  .media-container.media-main .html-container:after {\n    content: \"\";\n    position: absolute;\n    left: 63px;\n    top: -186px;\n    width: 100%;\n    height: 167%;\n    box-shadow: 22px 0px 0 #8e8e8e inset, 44px 0px 0 $color-light-type inset, 66px 0px 0 #8e8e8e inset, 88px 0px 0 $color-light-type inset, 110px 0px 0 #8e8e8e inset, 132px 0px 0 $color-light-type inset, 154px 0px 0 #8e8e8e inset, 176px 0px 0 $color-light-type inset, 198px 0px 0 #8e8e8e inset, 220px 0px 0 $color-light-type inset, 242px 0px 0 #8e8e8e inset, 264px 0px 0 $color-light-type inset, 286px 0px 0 #8e8e8e inset, 308px 0px 0 $color-light-type inset, 330px 0px 0 #8e8e8e inset, 350px 0px 0 $color-light-type inset, 372px 0px 0 #8e8e8e inset, 394px 0px 0 $color-light-type inset;\n    transform: rotate(135deg);\n    z-index: -9;\n  }\n\n  .media-container.media-main .html-container>div {\n    background: $color-light-type;\n    padding: 20px 20px;\n    position: relative;\n  }\n\n  .media-container.media-main .video-sect-imitation {\n    overflow: visible;\n  }\n\n  .media-container.media-main .video-sect-imitation .image-imitation {\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);\n  }\n}\n\n::ng-deep.practioner-dash-wrap--ss {\n  background: #F1F1F2;\n  border-radius: 6px;\n  color: #fff;\n  padding: 30px 38px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
